<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)">close</mat-icon>
  </div>
  <div class="content">
    <!-- <div class="text-right">
        <mat-slide-toggle [(ngModel)]="isAutoCompleteOn">
          Auto Complete</mat-slide-toggle
        >
      </div> -->
    <br />
    <div class="row">
      <div class="col-md-1">
        <label class="leg">Leg:</label>
      </div>
      <div class="col-md-2">
        <label class="date">Start Date:</label>
      </div>
      <div class="col-md-2">
        <label class="date">End Date:</label>
      </div>

      <div class="col-md-2">
        <label class="report">Excluded Dates:</label>
      </div>
      <div class="col-md-2">
        <label class="reason">Warranted Leg:</label>
      </div>
      <div class="col-md-2">
        <label class="reason">Reason:</label>
      </div>
      <div class="col-md-1">
        <label class="reason">Map:</label>
      </div>
    </div>
    <div *ngFor="let item of list; let i = index">
      <div class="row mb-2">
        <!-- Leg Name -->
        <div class="col-md-1">
          <p>{{ item.key }}</p>
        </div>

        <!-- Start Date Picker -->
        <!-- Start Date -->
        <div class="col-md-2">
          <input
            type="text"
            class="form-control"
            [formControl]="getFormControl('startDate' + item.index)"
          />
        </div>

        <!-- End Date -->
        <div class="col-md-2">
          <input
            type="text"
            class="form-control"
            [formControl]="getFormControl('endDate' + item.index)"
          />
        </div>

        <!-- Excluded Dates (Multiselect Dropdown) -->
        <div class="col-md-2">
          <div class="multi-select">
            <!-- Input box (click to open dropdown) -->
            <input type="text"
              class="form-control"
                   [value]="getSelectedText(getFormControl('excludedDates' + item.index).value)"
                   readonly
                   (click)="toggleDropdown(item.index)" />
          
            <!-- Dropdown -->
            <div class="dropdown" *ngIf="dropdownOpenIndex === item.index">
              <label *ngFor="let option of availableExcludedDates[item.index]">
                <input type="checkbox"
                       [checked]="isChecked(option, getFormControl('excludedDates' + item.index).value)"
                       (change)="toggleSelection(option, item.index)" />
                <span class="dropdownValues">{{ option }}</span>
              </label>
            </div>
          </div>
          
          
          
        </div>

        <!-- Warranted Leg Dropdown -->
        <div class="col-md-2">
          <select
            class="form-control"
            [formControl]="getFormControl('warrantedLeg' + item.index)"
          >
            <option value="" disabled>Select</option>
            <option *ngFor="let option of warrantedOptions" [value]="option">
              {{ option }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
           <input
            type="text"
            class="form-control"
            [formControl]="getFormControl('reason' + item.index)"
          />
        </div>
        <!-- Map Button -->
        <div class="col-md-1">
          <button type="button" class="btn btn-primary" (click)="openMapModal(item.key)" [disabled]="isLoadingMap" style="min-width: 44px; height: 38px; display: inline-flex; align-items: center; justify-content: center;">
            <mat-spinner *ngIf="isLoadingMap" diameter="18" class="map-spinner"></mat-spinner>
            <mat-icon *ngIf="!isLoadingMap">map</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="text-center mt-4">
      <button class="btn btn-light hover-clear clear" (click)="onSubmit('performance')">
        <span class="namestwo"> Generate performance Report</span>
      </button>
            <button class="btn btn-light hover-clear clear" (click)="onSubmit('periodic')" *ngIf="periodicId">
        <span class="namestwo"> Generate Periodic Report</span>
      </button>
      <!-- <button class="btn btn-light hover-clear clear" (click)="onSubmit(false)">
        <span class="namestwo"> Cancel</span>
      </button> -->
    </div>
  </div>
</div>
